"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GraphAttachPointProvider = void 0;
/**
 * @public
 * {@inheritDoc IGraphAttachPointProvider}
 */
class GraphAttachPointProvider {
    constructor(attachPointElement, template = chartMarkup) {
        this.attachPointElement = attachPointElement;
        // FIXME this won't work with most CSPs
        attachPointElement.innerHTML = template;
    }
    getCanvasElement() {
        return this.attachPointElement.getElementsByClassName("ecs-canvas")[0];
    }
    getWrapperElement() {
        return this.attachPointElement.getElementsByClassName("ecs-chart")[0];
    }
    getHiddenElement() {
        return this.attachPointElement.getElementsByClassName("ecs-hidden-element")[0];
    }
}
exports.GraphAttachPointProvider = GraphAttachPointProvider;
const chartMarkup = `
<div class="ecs-chart">
    <canvas class="ecs-canvas"></canvas>
    <div class="ecs-hidden-element"></div>
</div>
`;
//# sourceMappingURL=graph-attach-point-provider.js.map